module.exports = __webpack_public_path__ + "static/media/oc-fulll-logo.d7762d8c.svg";